<template>
    <modal
        name="whatsapp-community-modal"
        :adaptive="true"
        :focusTrap="true"
        :width="500"
        height="auto"
        :styles="{ boxShadow: 'none', background: 'transparent' }"
        overlayTransition="overlay"
        @opened="onOpened"
        @closed="onClosed"
    >
        <div class="rounded-lg bg-white px-6 sm:px-12 py-6 sm:py-10">
            <h2 class="text-center text-xl xs:text-2xl text-blue-700 mb-4">
                Join our Contract2Close WhatsApp Community
            </h2>

            <p class="text-center text-base text-gray-700 mt-4 mb-8 leading-normal">
                Stay connected, get quick updates, training links, and community support — right from your phone.
            </p>

            <div class="flex items-center justify-center space-x-6">
                <button type="button"
                    class="px-8 py-3 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-full font-semibold transition-colors flex-none"
                    @click="decline"
                >
                    Not Now
                </button>

                <button type="button"
                    ref="yesButton"
                    class="px-8 py-3 bg-blue-600 hover:bg-blue-500 text-white rounded-full font-semibold transition-colors flex-none"
                    @click="accept"
                >
                    Yes, Join the Community
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: 'WhatsAppCommunityModal',

    props: {
        show: {},
    },

    methods: {
        showModal() {
            this.$modal.show('whatsapp-community-modal');
        },
        onOpened() {
            this.$nextTick(() => {
                if (this.$refs.yesButton) {
                    this.$refs.yesButton.focus();
                }
            });
        },
        onClosed() {
            this.$emit('closed');
            this.hide();
        },
        hide() {
            this.$modal.hide('whatsapp-community-modal');
        },
        accept() {
            this.$emit('accepted', true);
            this.hide();
        },
        decline() {
            this.$emit('accepted', false);
            this.hide();
        },
    },

    watch: {
        show(val) {
            if (val) {
                this.showModal();
            }
        },
    },
}
</script>

<style scoped>
.vm--overlay {
    background: #000000;
    opacity: 0.7;
}

.overlay-enter,
.overlay-leave-to {
    opacity: 0;
}

.overlay-enter-active,
.overlay-leave-active {
    transition: all .3s;
}
</style>

